import React, { useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';

const CheckoutSuccess = () => {
  useEffect(() => {
    // Clear trial data and set as paid user
    localStorage.removeItem('trial_start');
    localStorage.setItem('subscription_status', 'active');
    
    toast.success('Welcome to Slack AI Assistant Pro! Your subscription is now active.', {
      duration: 5000
    });
    
    // Redirect to main app after 3 seconds
    setTimeout(() => {
      window.location.href = '/';
    }, 3000);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-8 h-8 text-green-600" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Successful!</h1>
        <p className="text-gray-600 mb-6">
          Thank you for subscribing to Slack AI Assistant Pro. Your account has been upgraded and you now have access to all premium features.
        </p>
        
        <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
          <h3 className="font-semibold text-green-800 mb-2">What's included:</h3>
          <ul className="text-sm text-green-700 space-y-1">
            <li>• Unlimited AI recommendations</li>
            <li>• Advanced filtering and search</li>
            <li>• Priority support</li>
            <li>• No usage limits</li>
          </ul>
        </div>
        
        <p className="text-sm text-gray-500">
          Redirecting you to the app in a few seconds...
        </p>
        
        <button
          onClick={() => window.location.href = '/'}
          className="mt-4 px-6 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
        >
          Go to App Now
        </button>
      </div>
    </div>
  );
};

export default CheckoutSuccess;